import { HttpClient } from 'common/HttpClient'
import { Environment } from 'enviroment/AppSettings'
import { ITextContentsState } from 'store/TextContentsSlice/TextContentsSliceModels'


//#region SettingService Instance
let instance: TextContentsService
//#endregion

//#region Interfaces
export interface  ITextContentsFetchModel {
  data: ITextContentsState;
}
//#endregion

class TextContentsService {
  private readonly _client: HttpClient;
  private readonly _settingsUrlPath = "settings";
  private readonly _textContentsUrlPath = "/textContents";
  constructor() {
   if (instance) { //SINGLETON DESIGN PATTERN
      throw new Error("New instance cannot be created!!");
   }

   instance = this;
    this._client = new HttpClient(Environment.apiUrl + this._settingsUrlPath);
  }

  public async getTextContents(): Promise<ITextContentsFetchModel> {
   const response = await this._client.get<any>(this._textContentsUrlPath);
   return response.data;
  }
}

let textContentsService = Object.freeze(new TextContentsService())//SINGLETON DESIGN PATTERN
export default textContentsService;